module.exports = __webpack_public_path__ + "static/img/1.29e5815.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/1.png
// module id = sNZo
// module chunks = 0